/* eslint-disable no-unused-vars */
/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { Select } from 'antd'
import { Country } from 'src/core/models'
import { CustomSelect } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { getCountryName } from 'src/core/json'
import { countryListSelector } from 'src/features'
import styles from './CountrySelector.module.scss'
import type { DefaultOptionType } from 'antd/lib/select'

interface CountrySelectorProps {
  name: 'country' | 'countries'
  mode?: 'multiple' | 'tags'
  required?: boolean
  placeholder: string
  handleOnChange?: (value: number) => void
}

const CountrySelector: React.FC<CountrySelectorProps> = (props) => {
  const { name, mode = null, required = false, placeholder, handleOnChange = null, ...restProps } = props
  const countryList: Country[] = useAppSelector(countryListSelector)

  const selectProps = {
    name: name,
    mode: mode,
    required: required,
    placeholder: placeholder,
    onChange: (value: number) => { if (handleOnChange) { handleOnChange(value) }},
    manageFiltering: (input: string, option: DefaultOptionType) => {
      const countryLabel = (option.children[1]?.props?.children as unknown as string)
      return countryLabel?.toLowerCase()?.includes(input?.toLowerCase())
    }
  }

  return <CustomSelect {...selectProps} {...restProps}>
    {countryList.map((country) => <Select.Option
      key={country.id} value={country.id}
    >
      <img
        src={country.flag}
        alt={`flag-${country?.name}`}
        className={styles.image}
      />
      <span className={styles.text}>
        {getCountryName(country?.code2, country?.name)}
      </span>
    </Select.Option>)}
  </CustomSelect>
}

export default CountrySelector
